const networksSection = $('#networks-section');
const networksCardsOverflow = networksSection.find('.networks-section-cards-overflow');
const overflowWidth = pxToVw(networksCardsOverflow.width());
const networksCards = networksSection.find('.review-card');
const controlsBtn = networksSection.find('.arrow-nav');
const leftOffsetsVw = networksCards
  .map(function (index, el) {
    return pxToVw($(el).position().left);
  })
  .get();

const lastCard = networksCards.last();
const lastCardRight = pxToVw(lastCard.position().left + lastCard.outerWidth(true));
const maxOffset = lastCardRight - overflowWidth + 3.75;
CustomEase.create('scrollEase', '0.60, 0.00, 0.40, 1.00');

const addAudioPlay = () => {
  networksCards.each(function () {
    const video = $(this).find('video');
    if (video.length != 0) {
      const playBtn = $(this).find('.review-card-play-btn');
      const pauseBtn = $(this).find('.review-card-pause-btn');
      const replayBtn = $(this).find('.review-card-replay-btn');
      let isPlayed = false;
      playBtn.on('click', function () {
        video.get(0).play();
        playBtn.css('z-index', '1010');
        pauseBtn.css('z-index', '1020');
      });
      pauseBtn.on('click', function () {
        video.get(0).pause();
        playBtn.css('z-index', '1020');
        pauseBtn.css('z-index', '1010');
      });
      replayBtn.on('click', function () {
        video.get(0).play();
        playBtn.css('z-index', '1010');
        pauseBtn.css('z-index', '1020');
        replayBtn.css('z-index', '1000');
      });

      $(video).on('ended', () => {
        playBtn.css('z-index', '1010');
        pauseBtn.css('z-index', '1000');
        replayBtn.css('z-index', '1020');
        video.get(0).pause();
        video.currentTime = 0;
      });
    }
  });
};

const scrollCards = (current, direction) => {
  const currentOffset = leftOffsetsVw[current];
  const staggerDirection = direction == 1 ? 'start' : 'end';
  const finalOffset = Math.min(maxOffset, currentOffset);
  btnStateControl(current, finalOffset == maxOffset ? current : undefined);

  gsap.to(networksCards, {
    x: `-${finalOffset}vw`,
    duration: 0.833,
    ease: 'scrollEase',
    stagger: {
      each: 0.1,
      from: staggerDirection,
    },
    overwrite: 'auto',
  });
};

const btnStateControl = (current, lastCard) => {
  controlsBtn.eq(0).prop('disabled', current == 0);
  controlsBtn.eq(1).prop('disabled', current == lastCard);
};

const addCardsControl = () => {
  let currentCardIndex = 0;
  btnStateControl(0, undefined);
  controlsBtn.on('click', function () {
    const direction = $(this).is(controlsBtn.eq(0)) ? -1 : 1;
    currentCardIndex += direction;
    scrollCards(currentCardIndex, direction);
  });
};

const addCardsEmbla = () => {
  const embla = networksSection.find('.embla');
  const viewport = embla.find('.embla__viewport');
  if (!window.EmblaCarousel || !viewport.length) {
    return;
  }
  const prevBtn = embla.find('.embla__button--prev');
  const nextBtn = embla.find('.embla__button--next');
  const OPTIONS = { align: 'start', dragFree: true, loop: false };
  const plugins = []; //[EmblaCarouselAutoScroll({ speed: 1, stopOnMouseEnter: true, stopOnInteraction: false })];
  const emblaApi = EmblaCarousel(viewport.get(0), OPTIONS, plugins);

  prevBtn.on('click', () => emblaApi.scrollPrev());
  nextBtn.on('click', () => emblaApi.scrollNext());

  const updateNavButtons = () => {
    if (!emblaApi.canScrollPrev()) prevBtn.prop('disabled', true);
    else prevBtn.prop('disabled', false);

    if (!emblaApi.canScrollNext()) nextBtn.prop('disabled', true);
    else nextBtn.prop('disabled', false);
  };

  emblaApi.on('select', updateNavButtons);
  emblaApi.on('init', updateNavButtons);
};

const networksCardsIn = () => {
  const networksCardsInTL = gsap.timeline({ paused: true });
  let cardsSumWidth = 0;
  networksCards.each(function (index) {
    networksCardsInTL.add(
      gsap.fromTo(
        $(this),
        {
          x: `${overflowWidth}vw`,
        },
        {
          x: 0,
          duration: 1.3,
          ease: 'scrollEase',
        }
      ),
      index * 0.1
    );
    cardsSumWidth += pxToVw($(this).outerWidth());
    if(cardsSumWidth >overflowWidth){
      return false;
    }
  });

  return networksCardsInTL;
};

const addNetworksCardsControl = () => {
  //btnStateControl(0, 1);
  addCardsEmbla();
  addAudioPlay();
  btnArrowHoverAnimation(controlsBtn);
}

const networksInAnimation = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };
  const networksTL = gsap.timeline({
    paused: true,
    onComplete: () => {
      //addCardsControl();
      addNetworksCardsControl();
    },
  });
  networksTL.add(
    animateSectionTopperIn({
      sectionParent: networksSection,
      gradientConfig: gradientConfig,
      descriptorStagger: 0.2,
    }).play(),
    0
  );
  //networksTL.add(networksCardsIn().play(), 0.4);

  return networksTL;
};

const networksTrigger = () => {
  const networksTL = networksInAnimation();
  const networksCardInTL = networksCardsIn();
  ScrollTrigger.create({
    trigger: networksSection,
    start: 'top top+=120%',
    end: 'top top+=20%',
    once: true,
    onUpdate: (self) => {
      networksTL.progress(self.progress);
    },
  });
  ScrollTrigger.create({
    trigger: networksSection,
    start: 'top center',
    end: 'top bottom',
    once: true,
    onEnter: () => {
      networksCardInTL.play();
    },
  });
};

/*
$(window).on('heroReady', () => {
networksTrigger();
});
*/
$(window).on('load', function(){
  addNetworksCardsControl();
})
addSectionObserver(networksSection, networksTrigger, false);